import { ID_INSTALLATION_ATTRIBUTE, ID_VIEW_MIRRORS_ATTRIBUTE } from '@shared/constants/keys';

export const splitArray = (arr: string[]) => {
  const filteredArr = arr.filter((item) => item !== ID_VIEW_MIRRORS_ATTRIBUTE && item !== ID_INSTALLATION_ATTRIBUTE);
  if (arr.length === 1) {
    return [filteredArr];
  }
  const mid = Math.floor(filteredArr.length / 2);
  const part1 = filteredArr.slice(0, mid);
  const part2 = filteredArr.slice(mid);
  return [part1, part2];
};
